<template>
  <div>
    <v-list-item :to="{name: states.sourceItemBuyoutItem.name, params: {sourceId: item.buyout.sourceId, buyoutId: item.buyout.id}}">
      <ImageBadged
            :icon="types[item.type].icon"
            :src="item.buyout.preview"
        ></ImageBadged>

      <v-list-item-content v-if="item.type === types.changeBuyoutStatus.id">
        <v-list-item-title>
          <b>{{item.buyout.title}}</b>: изменение статуса
        </v-list-item-title>
        <v-list-item-subtitle>
          {{item.ts | localizedDateEvents}}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          было:
          <b class="primary--text">
            {{buyoutStatuses[item.buyoutStatusPrevious].title}}
          </b>,
          стало:
          <b class="pink--text">
            {{buyoutStatuses[item.buyoutStatusCurrent].title}}
          </b>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-content v-if="item.type === types.fullPaymentSuccess.id">
        <v-list-item-title>
          <b>{{item.buyout.title}}</b>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{item.ts | localizedDateEvents}}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{item.initiator.fullName}} <b class="pink--text">подтвердил доплату</b>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-content v-if="item.type === types.paymentSuccess.id">
        <v-list-item-title>
          <b>{{item.buyout.title}}</b>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{item.ts | localizedDateEvents}}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{item.initiator.fullName}} <b class="pink--text">подтвердил оплату</b>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-content v-if="item.type === types.prepaymentSuccess.id">
        <v-list-item-title>
          <b>{{item.buyout.title}}</b>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{item.ts | localizedDateEvents}}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{item.initiator.fullName}} <b class="pink--text">подтвердил предоплату</b>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-content v-if="item.type === types.verifyBuyoutItem.id">
        <v-list-item-title>
          <b>{{item.buyout.title}}</b>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{item.ts | localizedDateEvents}}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{item.initiator.fullName}} <b class="pink--text">оформил ваш заказ</b>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
  </div>
</template>

<script>
import {types} from '@/constants'
import ImageBadged from '@/components/ImageBadged'
import {appStates} from '@/constants'
import Statuses from '@/services/statuses'

export default {
  name: 'EventListItem',
  components: {ImageBadged},
  data () {
    return {
      states: appStates,
      types: types.events,
      buyoutStatuses: Statuses.getStatuses()
    }
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>

</style>
